// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Decco from "decco/src/Decco.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as App_Types_Json$DvmAdminFrontendFr from "../../../types/App_Types_Json.bs.js";
import * as Messages_Pool_Expenses$DvmAdminFrontendFr from "../../../../intl/messages/poolExpenses/Messages_Pool_Expenses.bs.js";

function toString(status) {
  switch (status) {
    case /* ALLOCATIONS_TO_BE_CHECKED */0 :
        return "ALLOCATIONS_TO_BE_CHECKED";
    case /* CONTRACTS_MISCONFIGURATED */1 :
        return "CONTRACTS_MISCONFIGURATED";
    case /* ENGINE_TYPES_ADDED */2 :
        return "ENGINE_TYPES_ADDED";
    case /* ENGINE_TYPES_MISSING */3 :
        return "ENGINE_TYPES_MISSING";
    case /* REQUESTS_TO_BE_VALIDATED */4 :
        return "REQUESTS_TO_BE_VALIDATED";
    case /* VERSIONS_ADDED */5 :
        return "VERSIONS_ADDED";
    
  }
}

function fromString(status) {
  switch (status) {
    case "ALLOCATIONS_TO_BE_CHECKED" :
        return /* ALLOCATIONS_TO_BE_CHECKED */0;
    case "CONTRACTS_MISCONFIGURATED" :
        return /* CONTRACTS_MISCONFIGURATED */1;
    case "ENGINE_TYPES_ADDED" :
        return /* ENGINE_TYPES_ADDED */2;
    case "ENGINE_TYPES_MISSING" :
        return /* ENGINE_TYPES_MISSING */3;
    case "REQUESTS_TO_BE_VALIDATED" :
        return /* REQUESTS_TO_BE_VALIDATED */4;
    case "VERSIONS_ADDED" :
        return /* VERSIONS_ADDED */5;
    default:
      return ;
  }
}

var Decco$1 = App_Types_Json$DvmAdminFrontendFr.MakeStringableJsonType({
      toString: toString,
      fromString: fromString
    });

var NotificationType = {
  toString: toString,
  fromString: fromString,
  Decco: Decco$1
};

function toString$1(status) {
  switch (status) {
    case /* ALLOCATED_RESOURCES_CHANGED */0 :
        return "ALLOCATED_RESOURCES_CHANGED";
    case /* EXISTING_MR_ASSIGNED */1 :
        return "EXISTING_MR_ASSIGNED";
    case /* MR_DISASSIGNED */2 :
        return "MR_DISASSIGNED";
    case /* NEW_MR_ASSIGNED */3 :
        return "NEW_MR_ASSIGNED";
    
  }
}

function fromString$1(status) {
  switch (status) {
    case "ALLOCATED_RESOURCES_CHANGED" :
        return /* ALLOCATED_RESOURCES_CHANGED */0;
    case "EXISTING_MR_ASSIGNED" :
        return /* EXISTING_MR_ASSIGNED */1;
    case "MR_DISASSIGNED" :
        return /* MR_DISASSIGNED */2;
    case "NEW_MR_ASSIGNED" :
        return /* NEW_MR_ASSIGNED */3;
    default:
      return ;
  }
}

function toMessageString(status, intl, detail) {
  switch (status) {
    case /* ALLOCATED_RESOURCES_CHANGED */0 :
        return intl.formatMessage(Messages_Pool_Expenses$DvmAdminFrontendFr.allocatedResourcesChanged, {
                    period: detail
                  });
    case /* EXISTING_MR_ASSIGNED */1 :
        return intl.formatMessage(Messages_Pool_Expenses$DvmAdminFrontendFr.existingMrAssigned, {
                    mr: detail
                  });
    case /* MR_DISASSIGNED */2 :
        return intl.formatMessage(Messages_Pool_Expenses$DvmAdminFrontendFr.mrDisassigned, {
                    mr: detail
                  });
    case /* NEW_MR_ASSIGNED */3 :
        return intl.formatMessage(Messages_Pool_Expenses$DvmAdminFrontendFr.newMrAssigned, {
                    mr: detail
                  });
    
  }
}

var Decco$2 = App_Types_Json$DvmAdminFrontendFr.MakeStringableJsonType({
      toString: toString$1,
      fromString: fromString$1
    });

var MessageType = {
  toString: toString$1,
  fromString: fromString$1,
  toMessageString: toMessageString,
  Decco: Decco$2
};

function messageItem_encode(v) {
  return Js_dict.fromArray([
              [
                "messageType",
                Decco.optionToJson(Decco$2.t_encode, v.messageType)
              ],
              [
                "detail",
                Decco.optionToJson(Decco.stringToJson, v.detail)
              ]
            ]);
}

function messageItem_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var messageType = Decco.optionFromJson(Decco$2.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "messageType"), null));
  if (messageType.TAG === /* Ok */0) {
    var detail = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "detail"), null));
    if (detail.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                messageType: messageType._0,
                detail: detail._0
              }
            };
    }
    var e = detail._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".detail" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = messageType._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".messageType" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function parentChildItem_encode(v) {
  return Js_dict.fromArray([
              [
                "parent",
                Curry._1(Decco$1.t_encode, v.parent)
              ],
              [
                "child",
                Decco.listToJson(messageItem_encode, v.child)
              ]
            ]);
}

function parentChildItem_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var parent = Curry._1(Decco$1.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "parent"), null));
  if (parent.TAG === /* Ok */0) {
    var child = Decco.listFromJson(messageItem_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "child"), null));
    if (child.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                parent: parent._0,
                child: child._0
              }
            };
    }
    var e = child._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".child" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = parent._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".parent" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function notifications_encode(v) {
  return Decco.listToJson(parentChildItem_encode, v);
}

function notifications_decode(v) {
  return Decco.listFromJson(parentChildItem_decode, v);
}

export {
  NotificationType ,
  MessageType ,
  messageItem_encode ,
  messageItem_decode ,
  parentChildItem_encode ,
  parentChildItem_decode ,
  notifications_encode ,
  notifications_decode ,
}
/* Decco Not a pure module */
